var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5C15.9853 18.5 18 16.4853 18 14C18 11.5147 15.9853 9.5 13.5 9.5C11.0147 9.5 9 11.5147 9 14C9 16.4853 11.0147 18.5 13.5 18.5ZM13.5 18.5C18 18.5 19.8856 21 19.8856 21C21 19.25 22.1803 17 26.25 17M13.5 18.5C9 18.5 6 21.5 4.5 24.5M26.25 17C27.9069 17 29.25 15.6569 29.25 14C29.25 12.3431 27.9069 11 26.25 11C24.5931 11 23.25 12.3431 23.25 14C23.25 15.6569 24.5931 17 26.25 17ZM26.25 17C28.5 17 30 17.75 31.5 20C33 22.25 32.25 25.25 28.5 25.25H22.5C22.5 26.25 22.5 29 19.5 29H6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.716c168ba9b022643b4dff6d55b951b4.svg";
export { ForwardRef as ReactComponent };